<div class="user-profile">
  <ng-container *ngIf="userInfo$ | async as user">
    <div class="user-info">
      <span class="user-initials">
        {{ user.name ? user.name.charAt(0) : '' }}
        {{ user.familyName ? user.familyName.charAt(0) : '' }}
      </span>      
      <div class="user-details">
        <span class="user-name">{{ user.name + ' ' + user.familyName }}</span>
        <span class="user-email email-text">{{ user.email }}</span>
      </div>
    </div>
    <button mat-button class="custom-logout-button" (click)="logout()">LOG OUT</button>
  </ng-container>
</div>